import React, { useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AppConstants from "./../AppConstants";
import MyAppBar from "./appbar/my_appbar";
import Logo from "../../assets/HiFi-Red.svg";
import Menu from "./menu/menu";
import "./home.css";
import FranchMainScreen from "./content/franchise/franchMainScreen";
import StatusPage from "./content/statusPage/statusPage";
import BannerScreen from "./content/banner/bannerScreen";
import PaymentReport from "./content/paymentReport/paymentReport";
import EditRequest from "./content/editRequest/editRequest";
import UserScreen from "./content/user/userScreen";
import DateHoliday from "./content/dateHoliday/dateHoliday";
import Alert from "./content/alert/alert";
import OtherServices from "./content/otherServices/otherServices";
import { useNavigate } from "react-router-dom";
import Feedback from "./content/feedback/feedback";

const openedMixin = (theme) => ({
  width: AppConstants.drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: AppConstants.drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const Home = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedItemFromMenu, setSelectedItemFromMenu] = useState(0);



  const handleSelectedItemChange = (selectedItem) => {
    setSelectedItemFromMenu(selectedItem);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };


  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <MyAppBar
        open={open}
        selectedItemFromMenu={selectedItemFromMenu}
        sendDrawerOpen={handleDrawerOpen}
      />
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <img src={Logo} className="brand-logo" alt="" />
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <Menu open={open} sendSelectedItemToParent={handleSelectedItemChange} />
        <Divider />
        <List></List>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        {(() => {
          switch (selectedItemFromMenu) {
            case 0:
              return <StatusPage />;
            case 1:
              return <FranchMainScreen />;
            case 2:
              return <PaymentReport />;
            case 3:
              return <BannerScreen />;
           
            case 4:
              return <EditRequest />;
          
            case 5:
              return <UserScreen />;
            // case 6:
            //   return <DateHoliday />;
            case 6:
              return <Alert />;
            case 7:
              return <OtherServices />;
            // case 8:
            //   return <Feedback />;
            default:
              return <FranchMainScreen />;
          }
        })()}
      </Box>
    </Box>
  );
};

export default Home;
